import { useState,useEffect } from "react";
import "../styles/addPuzzle.css";
import { API_CONFIG } from "../config/api";
import { generateAuthToken,generateURN } from "../components/hmac";



const AddPuzzle = () => {
  const [courseData,setCourseData]=useState([]);
  const [level,setLevel]= useState("");
  const [modules, setModules] = useState([]);
  const [module,setModule]= useState("");
  const [topics, setTopics] = useState([]);
  const [topic, setTopic] = useState("");
  const [puzzleTopicId,setPuzzleTopicId] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formData, setFormData] = useState({
    topicId: "",
    puzzleTopicId: "",
    fen: "",
    solution: "",
    explaination: "",
    difficulty: "M",
    videoUrl: ""
  });

   useEffect(() => {
      fetchPuzzleInfo(level);
    }, [level]);


  const fetchPuzzleInfo=async(level)=>{
    try{
      if(level==="") return;
      const { host, fetchPuzzleInfo,basic } = API_CONFIG;
      const urn=generateURN();
      const authToken=generateAuthToken(urn);
      const res = await fetch(
        `https://${host}${fetchPuzzleInfo.path}`,
        {
          method: fetchPuzzleInfo.method,
          credentials: "include",
          headers:{
             Authorization:`Basic ${basic.BASIC_AUTH_CWUSER}`,
             urn:urn,
             authToken:authToken,
             level:level,
           }
        }
      );
      const json=await res.json();
      const data=json.apiResponseData.responseData;
      setCourseData(data);
    }catch(error){
      console.error("API ERROR",error);
    }
  }


   useEffect(() => {
      if (!topic) return;
      fetchLatestPuzzle(topic);
    }, [topic]);


  const fetchLatestPuzzle=async(topicId)=>{
    try{
     
      const { host, fetchLatestPuzzle,basic } = API_CONFIG;
      const urn=generateURN();
      const authToken=generateAuthToken(urn);
      const res = await fetch(
       `https://${host}${fetchLatestPuzzle.path}`,
        {
          method: fetchLatestPuzzle.method,
          credentials: "include",
          headers:{
             Authorization:`Basic ${basic.BASIC_AUTH_CWUSER}`,
             urn:urn,
             authToken:authToken,
             topicId:topicId
            }
        }
      );
      const json=await res.json();
      const data=json.apiResponseData.responseData;
      let latest=0;
      for(let i=0;i<data.length;i++){
        const pid = data[i]?.puzzleTopicId || "";
        const match = pid.match(/P(\d+)$/);
        const num = match ? Number(match[1]) : 0;
        if (num > latest) latest = num;
      }
      const next = latest + 1;
      const ans = `${topicId}P${next}`;
      setPuzzleTopicId(ans);
    }catch(error){
      console.error("API ERROR",error);
    }
  }


  useEffect(() => {
    const unique = [...new Set(courseData.map((c) => c.moduleId))];
    setModules(unique);
  }, [courseData]);


  useEffect(() => {
    if(!module) return;
    const filteredTopics = courseData
      .filter((item) => item.moduleId === module)
      .map((item) => ({ topicId: item.topicId, topic: item.topic }));
    setTopic("");
    setTopics(filteredTopics);
  }, [module,courseData]);



  /* -----------------------------
     HANDLE INPUT CHANGE
  ----------------------------- */
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  /* -----------------------------
     SUBMIT FORM → CALL BACKEND
  ----------------------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    const payload = {
      topicId: topic,
      puzzleTopicId: puzzleTopicId,
      fen: formData.fen,
      solution: formData.solution
        .split(",")
        .map((move) => move.trim())
        .filter(Boolean),
      explaination: formData.explaination,
      difficulty: formData.difficulty,
      videoUrl: formData.videoUrl
    };

    try {
      const { host,addPuzzle,basic } = API_CONFIG;
      const urn=generateURN();
      const authToken=generateAuthToken(urn,"admin");
      const res = await fetch(
        `https://${host}${addPuzzle.path}`,
        {
          method: addPuzzle.method,
          headers: {
            "Content-Type": "application/json",
             Authorization:`Basic ${basic.BASIC_AUTH_ADMIN}`,
             urn:urn,
             authToken:authToken,
          },
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || "Failed to add puzzle");
      }

      setMessage("✅ Puzzle added successfully");
      sessionStorage.clear();

      // reset form
      setFormData({
        topicId: "",
        puzzleTopicId: "",
        fen: "",
        solution: "",
        explaination: "",
        difficulty: "M",
        videoUrl: ""
      });
    } catch (err) {
      console.error(err);
      setMessage("❌ Failed to add puzzle");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-puzzle-page">
      <h1>Add Puzzle</h1>
      <p>Fill in all details carefully before submitting.</p>

      <form onSubmit={handleSubmit} className="add-puzzle-form">

       <select
          name="level"
          value={level}
          onChange={(e) => setLevel(e.target.value)}
          placeholder="level"
        >
          <option value="">--Level--</option>
          <option value="Beginner">Beginner</option>
          <option value="Intermediate">Intermediate</option>
          <option value="Advanced">Advanced</option>
        </select>

        {modules && (
          <select
          name="module"
          value={module}
          onChange={(e) => setModule(e.target.value)}
          placeholder="module"
        >
          <option value="">--Module--</option>
          {modules.map((c)=>(
             <option value={c}>{c}</option>
          ))}
        </select>
        )}

        {topics && (
          <select
          name="topic"
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          placeholder="topic"
        >
          <option value="">--Topic--</option>
          {topics.map((c)=>(
             <option value={c.topicId}>{`${c.topicId} -- ${c.topic}`}</option>
          ))}
        </select>
        )}

        {puzzleTopicId!=="" && (
          <div className="puzzle-id-box">
            <p><b>Topic ID:</b> {topic}</p>
            <p><b>Puzzle Topic ID:</b> {puzzleTopicId || "Generating..."}</p>
          </div>
        )}


        <textarea
          name="fen"
          placeholder="FEN string"
          value={formData.fen}
          onChange={handleChange}
          required
        />

        <textarea
          name="solution"
          placeholder="Solution moves (comma separated, e.g. Rf6, Kg8, e5)"
          value={formData.solution}
          onChange={handleChange}
          required
        />

        <textarea
          name="explaination"
          placeholder="Explanation"
          value={formData.explaination}
          onChange={handleChange}
          required
        />

        <select
          name="difficulty"
          value={formData.difficulty}
          onChange={handleChange}
        >
          <option value="E">Easy</option>
          <option value="M">Medium</option>
          <option value="H">Hard</option>
        </select>

        <input
          name="videoUrl"
          placeholder="Video URL"
          value={formData.videoUrl}
          onChange={handleChange}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Add Puzzle"}
        </button>
      </form>

      {message && (
        <p
          className={`add-puzzle-message ${
            message.startsWith("✅") ? "success" : "error"
          }`}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default AddPuzzle;
